// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img.svelte-1st9kqc{position:absolute;top:0;left:0;overflow:hidden;height:100%;width:100%;border-radius:6px 6px 0 0}.horisontal.svelte-1st9kqc{border-radius:6px 0 30px 6px}.aspect.svelte-1st9kqc{overflow:hidden;position:relative;width:100%;border-radius:6px 6px 0 0}.aspectBig.svelte-1st9kqc{padding-top:calc((9 / 16) * 100%)}.aspectMedium.svelte-1st9kqc{padding-top:calc((3.5 / 3) * 100%)}.aspectSmall.svelte-1st9kqc{padding-top:calc((2 / 3) * 100%);border-radius:6px 0 30px 6px}", ""]);
// Exports
module.exports = exports;
